<template>
    
    <main class="CuponesHome-MAIN DISPLAY">
        
    <main class="INNER-MARGIN">
        <BuscadorStandalone/><!--v-if="TEST"-->

        <!-- banner -->
        <div ref="sliderBanner" class="general-slider sliderBanner">
            <a v-for="(item, index) in sliders.Banner.content" :key="index" :href="getFrontURL()+'/cupon/?cupon='+item.cupon_id">
                <img :src="item.banner_url">
            </a>
        </div>
        <div class="slider-buttons">
            <button
                v-for="(item, index) in sliders.Banner.content" :key="index"
                @click="setSliderIndex('Banner', index)"
                :class="`active-btn-${index == sliders.Banner.current}`"
            >
            </button>
        </div>

        <div class="promos-logo-container">
            <img src="../assets/MisPromos-logo.png"/>
        </div>

        <!-- cupones para ti -->
        <section class="section-cupones-para-ti">
            <h3>Cupones para ti</h3>
            <p>Conoce las ofertas basadas en tus intereses</p>

            <div class="switches">
                <button @click="switchView = 'todos'" :class="{ 'switches-btn-on': switchView == 'todos' }">Todos</button>
                <button @click="switchView = 'categorias'" :class="{ 'switches-btn-on': switchView == 'categorias' }">Por categorías</button>
            </div>

            <div class="cupones-para-ti" v-if="switchView == 'todos'">
                <a v-for="(item, index) in cupones" :key="index" :href="getFrontURL()+'/cupon/?cupon='+item.id">
                    <img :src="item.url_banner" @error="(e) => { e.target.onerror = null; e.target.src = 'https://promo-colaboradores.ideeo.mx/cupones/NULL%20BANNER.png';}">
                </a>
            </div>

            <div v-if="switchView == 'categorias'">
                <section class="section-categorias">
                    <div v-for="(item, index) in categories" :key="index" @click="setCategory(item.id)">
                        <div :style="`background-color: ${item.color};`"><img :src="require(`../assets/${item.icon}`)"/></div>
                        <img :src="require(`../assets/${item.bg}`)">
                        <p>{{ item.name }}</p>
                    </div>
                </section>
            </div>
        </section>

        <!--flash-->
        <section class="section-cupones-flash">
            <h3>Cupones flash</h3>
            <p>¡Ofertas por tiempo limitado!</p>

            <div class="cupones-flash" ref="cuponesFlashScrollable">
                <a v-for="(item, index) in sliders.Flash.content" :key="index" :href="getFrontURL()+'/cupon/?cupon='+item.id">
                    <img :src="item.url_banner">
                </a>
                <a v-for="(item, index) in sliders.Flash.content" :key="index" :href="getFrontURL()+'/cupon/?cupon='+item.id">
                    <img :src="item.url_banner">
                </a><!-- <- duplicado -->
            </div>
            <img src="../assets/arrow.png" class="CuponesHome-arrow" @click="setSliderFlash('back')"/>
            <img src="../assets/arrow.png" class="CuponesHome-arrow-reverse" @click="setSliderFlash('next')"/>
        </section>

        <section class="section-cupones-para-ti" v-if="TEST">
            <h3>Cupones por temporada</h3>
            <div class="cupones-para-ti">
                <a v-for="(item, index) in cuponesPorTemporada" :key="index" :href="getFrontURL()+'/cupon/?cupon='+item.id">
                    <img :src="item.url_banner" @error="(e) => { e.target.onerror = null; e.target.src = 'https://promo-colaboradores.ideeo.mx/cupones/NULL%20BANNER.png';}">
                </a>
            </div>
        </section>

        <br><br>

        <!-- TEST -->
        <!--<div v-for="(item, index) in cupones" :key="index" style="border: 1px solid red; display: grid; grid-template-columns: 1fr 1fr 1fr 1fr;">
            <div><h1>{{ item.cupon_id }}</h1> {{ item.nombre }}</div>
            <img :src="item.url_logo" style="max-width: 100%; max-height: 100%;"/>
            <img :src="item.url_banner" style="max-width: 100%; max-height: 100%;"/>
            <img :src="item.url_imagen" style="max-width: 100%; max-height: 100%;"/>
        </div>-->
        
    </main>
    </main>
</template>

<script>
import BuscadorStandalone from './BuscadorStandalone.vue';

export default {
    name: 'CuponesHome',
    components: {
        BuscadorStandalone,
    },
    data(){
        return{
            TEST: (localStorage.getItem("m_usuario") == "XMZ9238") || window.location.href.includes("localhost"),
            sliders: {
                Banner: {
                    content: [ // api lista
                        require('../assets/examples/sliderBanner.png'),
                        require('../assets/examples/sliderBanner.png'),
                        require('../assets/examples/sliderBanner.png')
                    ],
                    current: 0,
                    interval: undefined,
                },
                Flash: {
                    content: [
                        require('../assets/examples/sliderFlash.png'),
                        require('../assets/examples/sliderFlash.png'),
                        require('../assets/examples/sliderFlash.png'),
                        require('../assets/examples/sliderFlash.png'),
                        require('../assets/examples/sliderFlash.png'),
                        require('../assets/examples/sliderFlash.png'),
                    ],
                    current: 0,
                },
                /*Temporada: {
                    content: [
                        require('../assets/examples/cuponTemporada.png'),
                        require('../assets/examples/cuponTemporada.png'),
                        require('../assets/examples/cuponTemporada.png'),
                        require('../assets/examples/cuponTemporada.png'),
                        require('../assets/examples/cuponTemporada.png'),
                        require('../assets/examples/cuponTemporada.png'),
                    ],
                    current: 0,
                }*/
            },
            cupones: [],
            cuponesPorTemporada: [],
            switchView: 'categorias', // 'todos' | 'categorias'
            categories: [
                {id: 11, color: "#EEFFE9", name: "Vida independiente", icon: "decease.png", bg: "min-cover-vida-independiente.png"},
                {id: 1, color: "#FFFAE2", name: "A la aventura", icon: "aeroplane.png", bg: "min-cover-a-la-aventura.png"},
                {id: 6, color: "#FFEEFE", name: "Mundo digital", icon: "business-inteligent.png", bg: "min-cover-vida-digital.png"},
                {id: 5, color: "#D4D1FC", name: "Mundo Fitness", icon: "bicycle.png", bg: "min-cover-fitness.png"},
                {id: 7, color: "#D7E8FC", name: "Vida en compañía", icon: "couple.png", bg: "min-cover-compania.png"},

                {id: 12, color: "#FCE677", name: "Detalles que inspiran", icon: "kids.png", bg: "min-cover-detalles.png"}, //faltan ids reales
                {id: 13, color: "#9FE38E", name: "Ecovibes", icon: "climate-action.png", bg: "min-cover-eco.png"}, //faltan ids reales
                {id: 14, color: "#92C8FB", name: "Cuida tu salud", icon: "insurance.png", bg: "min-cover-salud.png"}, //faltan ids reales
                {id: 3, color: "#4DCEC1", name: "Foodie", icon: "food-and-restaurant.png", bg: "min-cover-foodie.png"},
                {id: 2, color: "#FFB56B", name: "Estudiante", icon: "inclusive-growth.png", bg: "min-cover-estudiante.png"},
            ],
        }
    },
    methods: {
        startSlider(slider_){
            const slider = this.$refs[`slider${slider_}`];
            const num = this.sliders[slider_].content.length;
            const w = slider.offsetWidth;
            
            setInterval(()=>{
                if(this.sliders[slider_].current >= num-1){
                    this.sliders[slider_].current = 0;
                }else{
                    this.sliders[slider_].current++;
                }
                slider.scroll(w*this.sliders[slider_].current, 0);        
            }, 4000);
        },

        setSliderIndex(slider_, index_){
            const slider = this.$refs[`slider${slider_}`];
            const w = slider.offsetWidth;
            
            this.sliders[slider_].current = index_;
            slider.scroll(w*this.sliders[slider_].current, 0);
            console.log(index_, index_*this.sliders[slider_].current)
        },

        setSliderFlash(index_) {
            const slider = this.$refs.cuponesFlashScrollable;
            if (!slider) return;

            const distance = slider.offsetWidth; // ancho visible del slider

            if (index_ === "next") {
                slider.scrollBy({ 
                    left: distance, 
                    behavior: "smooth" 
                });
            } else if (index_ === "back") {
                slider.scrollBy({ 
                    left: -distance, 
                    behavior: "smooth" 
                });
            }
        },

        setSliderTemporada(direction_){
            const slider = this.$refs.sliderTemporada;
            const w = slider.offsetWidth;
            const dir = direction_ == 'next' ? +1 : -1;
            slider.scrollLeft = slider.scrollLeft += ((w/4)*dir);
        },

        async getBanners(){
            try {
                const response = await fetch("https://promo-colaboradores.ideeo.mx/api/banners", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        id: "1"
                    })
                });
                const result = await response.json();
                this.sliders.Banner.content = result.data;   
                this.startSlider('Banner');
            } catch (error) {
                console.error("Error en la solicitud:", error);
            }
        },
        
        async getCupones(id_, tipoCupon_){
            try {
                const response = await fetch("https://promo-colaboradores.ideeo.mx/api/cupones", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        id: id_.toString(),
                        tipo_cupon: tipoCupon_.toString(),
                    })
                });

                const result = await response.json();
                //console.log("Respuesta del servidor:", tipoCupon_, result.data);

                if(tipoCupon_ == 1){
                    this.cupones = result.data;
                }else
                if(tipoCupon_ == 2){
                    this.sliders.Flash.content = result.data;
                    this.setSliderFlash('start');
                }else
                if(tipoCupon_ == 3){
                    this.sliders.Temporada.content = result.data;
                }
            } catch (error) {
                console.error("Error en la solicitud:", error);
            }
        },

        async getCuponesPorTemporada(){
            const response = await fetch("https://promo-colaboradores.ideeo.mx/api/temporal", {
                method: "POST"
            })
            const result = await response.json();
            this.cuponesPorTemporada = result?.data ?? [];
        },

        getFrontURL(){
			return window.location.origin;
		},

        setCategory(detalle_){
            window.location.href = this.getFrontURL() + "/categoriadetalle/?categoria=" + detalle_;  
        }
    },
    mounted(){
        this.getBanners()
        .catch(error => {
            console.error("Intentando recargar:", error);
            setTimeout(() => {
                this.getBanners();
            }, 6_000);
        });

        this.getCupones(1, 1)
        .catch(error => {
            console.error("Intentando recargar:", error);
            setTimeout(() => {
                this.getCupones(1, 1);
            }, 6_000);
        });

        this.getCupones(1, 2)
        .catch(error => {
            console.error("Intentando recargar:", error);
            setTimeout(() => {
                this.getCupones(1, 2);
            }, 6_000);
        });

        //this.getCupones(1, 3);
        this.getCuponesPorTemporada()
        .catch(error => {
            console.error("Intentando recargar:", error);
            setTimeout(() => {
                this.getCuponesPorTemporada();
            }, 5_000);
        });

    }
}
</script>

<style scoped lang="stylus">
.CuponesHome-MAIN{
    background-color: #f3fbff;
    font-family: 'Benton Sans BBVA book';
    color: #0D2F6E;
}

h3, section > p, .INNER-MARGIN > p{
    width: 100%;
    text-align: center;
}

h3{
    font-weight: 200;
    color: white;
    background-color: #051283;
    width: fit-content;
    margin-left: auto;
    margin-right: auto;
    padding: 0 1ch;
}

section > p, .INNER-MARGIN > p{
    margin-top: -1.5ch;
}

.CuponesHome-arrow, .CuponesHome-arrow-reverse{
    width: 3.5ch;
    z-index: 5;
    cursor: pointer;
}

.CuponesHome-arrow-reverse{
    rotate: 180deg;
}

/* slider Banner */
.sliderBanner a{
    min-width: 100%;
    width: 100%;
}

.sliderBanner img{
    min-width: 100%;
    width: 100%;
}

.promos-logo-container{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 2ch;
}

.promos-logo-container > img{
    width: 20ch;
}

/* cupones para ti */
.section-cupones-para-ti{
    background-color: #92c8fb5f;
    border-radius: 1ch;
    padding: 2ch;
    padding-top: 0.5ch;
    margin-top: 3ch;
}

.cupones-para-ti{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 1ch;
}

.cupones-para-ti a{
    width: 100%
}

.cupones-para-ti img{
    width: 100%;
    max-width: 100vw;
}

.switches{
    background-color: white;
    border-radius: 100vw;
    display: flex;
    align-items: center;
    width: fit-content;
    margin: 0 auto;
    margin-bottom: 2ch;
}

.switches button{
    border: none;
    border-radius: 100vw;
    padding: 1ch 2ch;
    background-color: transparent;
    min-width: 10ch;
    color: #2B3D75;
    cursor: pointer;
}

.switches-btn-on{
    color: white !important;
    background-color: #051283 !important;
}

.section-cupones-para-ti > div

    .section-categorias
        display: grid
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr
        grid-gap: 3ch 2.5ch
        margin-top: 5ch
        
        >div
            display: flex
            flex-direction: column
            align-items: center
            position: relative
            cursor: pointer

            >div
                display: flex
                align-items: center
                justify-content: center
                aspect-ratio: 1/1
                width: 3.3ch
                max-width: 3.3ch
                height: 3.3ch
                max-height: 3.3ch
                padding: 1ch
                border-radius: 100vw
                position: absolute
                top: -2ch
                right: 2.5ch

                img
                    max-width: 100%
                    max-height: 100%

            >img
                background-color: lightgray
                width: 100%
                aspect-ratio: 4/3
                border-radius: 1.5ch

            >p
                font-family: 'Benton Sans BBVA Medium'
                color: #001391
                text-align: center

/* slider flash */
.section-cupones-flash{
    background-color: #FFEFDE;
    border-radius: 1ch;
    padding: 2ch;
    padding-top: 0.5ch;
    margin-top: 3ch;
    position: relative;
}

.cupones-flash{
    display: flex;
    overflow: auto;
}

.cupones-flash img{
    width: 22.5vw;
    margin: 0 1vw;    
}

.section-cupones-flash .CuponesHome-arrow, .section-cupones-flash .CuponesHome-arrow-reverse{
    position: absolute;
    margin: 0;
    top: 50%;
}

.section-cupones-flash .CuponesHome-arrow{
    left: calc(0% - 1.5ch);
}

.section-cupones-flash .CuponesHome-arrow-reverse{
    right: calc(0% - 1.5ch);
}

/* RESPONSIVE */
@media all and (max-width:780px){

    .cupones-para-ti{
        grid-template-columns: 1fr;
    }

    .cupones-flash img{
        width: 55vw;
    }

    .section-categorias{
        grid-template-columns: 1fr 1fr !important;
    }

}
</style>